module.exports = __webpack_public_path__ + "static/media/caret-right.80fdbf28.svg";